import React from "react";

import { defineMessages, useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import Interactive from "@app/component/map/FeaturedMap/essentials/controls/Interactive";
import StickyBar from "@app/scene/map/components/tools/StickyBar";

import styles from "./PinDropToolPanel.module.scss";

interface Props {
  onExit: () => void;
}

const messages = defineMessages({
  text: {
    id: "map.tool.pinDrop.toolbar.text",
    defaultMessage: "Click and drag the pin to adjust its location",
    description: "Pin Drop Mode description",
  },
  title: {
    id: "map.tool.pinDrop.toolbar.exitButton",
    defaultMessage: "Exit Pin Drop Mode",
    description: "Exit Pin Drop Mode button title",
  },
});

const PinDropToolPanel: React.FC<Props> = ({ onExit }) => {
  const intl = useIntl();

  return (
    <Interactive>
      <StickyBar className={styles.container}>
        <div className={styles.content}>{intl.formatMessage(messages.text)}</div>

        <div className={styles.action}>
          <Button onClick={onExit}>{intl.formatMessage(messages.title)}</Button>
        </div>
      </StickyBar>
    </Interactive>
  );
};

export default PinDropToolPanel;
